
import { Route, Routes } from 'react-router-dom';
import SettingsPage from './SettingsPage';
import Login from './Login';
import ManageEmployees from './ManageEmployees';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from "@azure/msal-browser";
import Home from './Home';


const AppRouter = () => {
  return (
    <div className='App'>
      <Routes>
        <Route
          path="/"
          element={
            <MsalAuthenticationTemplate interactionType={InteractionType.Popup}
             >
              <Login />
            </MsalAuthenticationTemplate>
          }
        />
        <Route path="/home" element={<Home />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/manage-employees" element={<ManageEmployees />} />
      </Routes>
    </div>
  );
};

export default AppRouter;



